import { useEffect, useRef, useState } from 'react';
import { TTool } from 'types/apis/chart/studentPracticeChart';

type TLine = {
  tool: TTool;
  points: number[];
  strokeWidth: number;
  strokeColor: string;
};

type TProps = {
  tool: TTool;
  strokeWidth: number;
  strokeColor: string;
  lines: TLine[];
  setLines: (lines: TLine[]) => void;
};

const useCanvas = ({
  tool,
  strokeWidth,
  strokeColor,
  lines,
  setLines,
}: TProps) => {
  const isDrawing = useRef(false);

  const handleTouchStart = (e: any) => {
    e.evt.preventDefault();
    isDrawing.current = true;
    const pos = e.target.getStage().getPointerPosition();
    setLines([
      ...lines,
      { tool, points: [pos.x, pos.y], strokeWidth, strokeColor },
    ]);
  };

  const handleTouchMove = (e: any) => {
    e.evt.preventDefault();
    if (!isDrawing.current) {
      return;
    }
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    const lastLine = lines[lines.length - 1];
    lastLine.points = lastLine.points.concat([point.x, point.y]);

    const newLines = lines.slice(0, lines.length - 1);
    setLines([...newLines, lastLine]);
  };

  const handleTouchEnd = (e: any) => {
    e.evt.preventDefault();
    isDrawing.current = false;
  };

  const useImage = (url: string): [HTMLImageElement | undefined] => {
    const [image, setImage] = useState<HTMLImageElement>();

    useEffect(() => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        setImage(img);
      };
    }, [url]);

    return [image];
  };

  return { handleTouchMove, handleTouchEnd, handleTouchStart, useImage };
};

export default useCanvas;
